import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from '../../../services/app.service';

@Component({
  selector: 'app-viewer-helpmodal',
  standalone: false,
  templateUrl: './helpmodal.component.html',
  styleUrls: ['./helpmodal.component.scss'],
})
export class HelpModalComponent {
  constructor(
    public activeModal: NgbActiveModal,
    private cookieService: CookieService,
    public appService: AppService
  ) { }

  changeAutoSettings() {
    this.cookieService.set(
      'autoChangeSite',
      this.appService.autoChangeSite.toString(),
      999,
      null,
      null,
      false,
      'Lax'
    );
  }
}
